
export function RetiraAcentos(str: string): string {

    let com_acento = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ";
    let sem_acento = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr";
    let novastr = "";
    let troca: boolean;

    if(str === undefined || str === null || str === ""){
        return ""
    }

    for (let i = 0; i < str.length; i++) {
        troca = false;
        for (let y = 0; y < com_acento.length; y++) {
            if (str.substring(i, i + 1) === com_acento.substring(y, y + 1)) {
                novastr += sem_acento.substring(y, y + 1);
                troca = true;
                break;
            }
        }
        if (troca === false) {
            novastr += str.substring(i, i + 1);
        }
    }
    return novastr;
}       